import PropTypes from 'prop-types';
import React, { useState } from 'react';

var _ = require('lodash');
import AsyncCreatableSelect from 'react-select/async-creatable';
import Select from 'react-select';
const axios = require('axios').default;
import Popup from "reactjs-popup";
import PageSectionMenu from './PageSectionMenu';
import { SectionTitle } from './ClassicSectionCard';
import InputMask from "react-input-mask";
import TicketUpdatePreferencesModal from './TicketUpdatePreferencesModal';
import contactTypeOptions from '../../shared/constants/contactTypeOptions';
import { mergeSelectStyles } from '../../../shared/darkSelectStyles';
import { Modal } from '@opendate-app/setlist';
import {
  SEND_TICKET_COUNTS_NOW_LABEL,
  SEND_TICKET_COUNTS_NOW_TITLE,
  sendTicketCountsNowMessage,
  ticketCountsEventLabel,
  useSendTicketCountsNow
} from '../utils/sendTicketCountsNow';

const SendTicketCountsNowMenuItem = ({ sendNow, sending, onSelect }) => {
  if (sendNow.available && !sending) {
    return (
      <li className="list-group-item">
        <a href="#"
           onClick={(e) => { e.preventDefault(); onSelect(); }}
           className="text-muted"
           data-testid="manage-contacts-send-ticket-counts">
          <span className="d-inline-block text-center" style={{width: "28px"}}>
            <i className="fas fa-paper-plane"></i>
          </span>
          <span className="text-dark">{SEND_TICKET_COUNTS_NOW_LABEL}</span>
        </a>
      </li>
    );
  }

  const reason = sending ? "Sending…" : sendNow.reason;
  return (
    <li className="list-group-item text-muted"
        aria-disabled="true"
        title={reason}
        data-testid="manage-contacts-send-ticket-counts-disabled">
      <span className="d-inline-block text-center" style={{width: "28px"}}>
        <i className="fas fa-paper-plane"></i>
      </span>
      {SEND_TICKET_COUNTS_NOW_LABEL}
      <div className="small pl-4">{reason}</div>
    </li>
  );
};

SendTicketCountsNowMenuItem.propTypes = {
  sendNow: PropTypes.shape({ available: PropTypes.bool, reason: PropTypes.string }).isRequired,
  sending: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired
};

const contactTypePopupSelectStyles = {
  container: (base) => ({
    ...base,
    fontSize: "14px",
    minWidth: "280px",
  }),
  control: (base, state) => ({
    ...base,
    minHeight: "36px",
    borderRadius: "8px",
    backgroundColor: "var(--od-c-ffffff, #fff)",
    borderColor: state.isFocused ? "#80bdff" : "var(--od-c-ced4da, #ced4da)",
    boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : "none",
    "&:hover": {
      borderColor: state.isFocused ? "#80bdff" : "var(--od-c-ced4da, #ced4da)",
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 8px",
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
    color: "var(--od-c-333333, #333)",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  dropdownIndicator: () => ({
    display: "none",
  }),
  placeholder: (base) => ({
    ...base,
    color: "var(--od-c-6c757d, #6c757d)",
  }),
  menu: (base) => ({
    ...base,
    position: "relative",
    boxShadow: "none",
    marginTop: "4px",
    border: "none",
    backgroundColor: "var(--od-c-ffffff, #fff)",
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: "200px",
    paddingTop: 0,
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused ? "var(--od-c-f8f9fa, #f8f9fa)" : "var(--od-c-ffffff, white)",
    color: "var(--od-c-000000, black)",
    padding: "8px 12px",
    cursor: "pointer",
    "&:active": {
      backgroundColor: "var(--od-c-e9ecef, #e9ecef)",
    },
  }),
};

const contactTypePopupContentStyle = {
  background: "var(--sl-bg-primary)",
  border: "none",
  borderRadius: "8px",
  boxShadow: "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  width: "300px",
  padding: "12px",
  zIndex: "9999",
};

const contactTypeTriggerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  minHeight: "31px",
  padding: "0 8px",
  borderRadius: "8px",
  border: "1px solid var(--od-c-ced4da, #ced4da)",
  backgroundColor: "var(--od-c-ffffff, white)",
  cursor: "pointer",
  fontSize: "14px",
};

const selectStyles = mergeSelectStyles({
  container: (base) => ({ ...base, zIndex: "999" })
});

const popupContentStyle = {
  "background": "var(--sl-bg-primary)",
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "260px",
  "padding": "0px",
  "zIndex": "1999"
}

const canAddCalendarEventContact = (calendarEventContacts) => {
  return !calendarEventContacts.some((calendarEventContact) => {
    return calendarEventContact.id === undefined;
  });
}

const hasManuallyAddedCalendarEventContacts = (calendarEventContacts) => {
  return calendarEventContacts.some((calendarEventContact) => {
    return !calendarEventContact.auto_added;
  });
}

const canSubmitCalendarEventContactForm = (calendarEventContact) => {
  var noPhoneOrValidPhone = (
    calendarEventContact
      && calendarEventContact.contact
      && (
        !calendarEventContact.contact.phone
          || calendarEventContact.contact.phone.length === 0
          || calendarEventContact.contact.phone.replace(/[^0-9]/g, '').length === 10
      )
  )

  return (
    calendarEventContact
      && calendarEventContact.contact
      && calendarEventContact.contact.name
      && calendarEventContact.contact.name.length > 0
      && noPhoneOrValidPhone
  );
}

const formatOptionLabel = ({ value, label, title_email_preview }) => {
  return (
    <div>
      <div style={{"fontSize": "12px"}}>{label}</div>
      {title_email_preview && title_email_preview.length > 0 ? (
        <div className="text-muted" style={{"fontSize": "10px"}}>
          {title_email_preview}
        </div>
      ) : null}
    </div>
  );
};

const debouncedFetch = _.debounce((inputValue, callback, team, calendarEventContacts) => {
  var omitContactIds = calendarEventContacts.filter((calendarEventContact) => {
      return calendarEventContact.contact;
    })
    .map((calendarEventContact) => {
      return calendarEventContact.contact.id;
    });

  var contactPromise = axios.get('/teams/' + team.id + '/contacts/autocomplete', {
      params: {
        name: inputValue,
        omit_ids: omitContactIds
      }
    })
    .then(function (response) {
      return response.data.map(function(data){
        return Object.assign({}, data, {value: data.id, label: data.name, type: "Contact"});
      });
    })

  var agentPromise = axios.get('/agents/autocomplete', {
      params: {
        name: inputValue,
        team_id: team.id
      }
    })
    .then(function (response) {
      return response.data.map(function(data){
        return Object.assign({}, data, {value: data.id, label: data.name, type: "Agent"});
      });
    })

  Promise.all([contactPromise, agentPromise]).then((values) => {
    var combined = values.flat().sort(function (a, b) {
      return a.name.localeCompare(b.name);
    }).slice(0, 20);

    callback(combined);
  });
}, 250);

const ManageContacts = ({
  csrfToken,
  team,
  confirm,
  currentUser,
  calendarEventContacts,
  createCalendarEventContactFromContactId,
  deleteCalendarEventContact,
  addCalendarEventContact,
  removeUnsavedCalendarEventContact,
  editCalendarEventContact,
  cancelEditCalendarEventContact,
  updateCalendarEventContactName,
  updateCalendarEventContactEmail,
  updateCalendarEventContactPhone,
  updateCalendarEventContactContactType,
  updateCalendarEventContactTitle,
  updateCalendarEventContactCompanyName,
  submitCalendarEventContactForm,
  editUnsavedCalendarEventContact,
  originalCalendarEventContact,
  createCalendarEventContactFromAgentId,
  updateCalendarEventContact,
  sendCalendarEventContactTicketCounts,
  confirmInvitationChanged,
  emailsToInviteChanged,
  confirmInvitationsAndTeamMemberships,
  confirmPageSection,
  fetchPermissionSet,
  updateConfirmPageSection
}) => {
  const [preferencesModalOpen, setPreferencesModalOpen] = useState(false);
  const [preferencesModalContact, setPreferencesModalContact] = useState(null);
  const [preferencesModalIndex, setPreferencesModalIndex] = useState(null);
  const [preferencesModalSaving, setPreferencesModalSaving] = useState(false);
  const [sendNowTarget, setSendNowTarget] = useState(null);
  const [sendingNowId, setSendingNowId] = useState(null);
  const sendTicketCountsNowState = useSendTicketCountsNow(calendarEventContacts);

  const confirmSendNow = () => {
    const { calendarEventContact } = sendNowTarget;
    setSendNowTarget(null);
    setSendingNowId(calendarEventContact.id);
    sendCalendarEventContactTicketCounts(csrfToken, team, calendarEventContact)
      .finally(() => setSendingNowId(null));
  };

  const openPreferencesModal = (calendarEventContact, index) => {
    setPreferencesModalContact(calendarEventContact);
    setPreferencesModalIndex(index);
    setPreferencesModalOpen(true);
  };

  const closePreferencesModal = () => {
    setPreferencesModalOpen(false);
    setPreferencesModalContact(null);
    setPreferencesModalIndex(null);
    setPreferencesModalSaving(false);
  };

  const handlePreferencesSave = (params) => {
    setPreferencesModalSaving(true);
    updateCalendarEventContact(csrfToken, team, preferencesModalContact, params, preferencesModalIndex)
      .then(() => {
        closePreferencesModal();
      })
      .catch(() => {
        // Error is already toasted by the action creator
        setPreferencesModalSaving(false);
      });
  };

  return (
  <div className="card no-border shadow-2">
    <div className="card-body px-md-3">
      <div className="row">
        <div className="col">
          <SectionTitle title="Contacts"
                        count={calendarEventContacts.length}
                        locked={Boolean(confirmPageSection.permission_set_id)} />
        </div>
        <div className="col-xs-auto" style={{"paddingRight": "15px"}}>
          <PageSectionMenu csrfToken={csrfToken}
                           team={team}
                           confirm={confirm}
                           currentUser={currentUser}
                           confirmPageSection={confirmPageSection}
                           fetchPermissionSet={fetchPermissionSet}
                           updateConfirmPageSection={updateConfirmPageSection} />
        </div>
      </div>
      {calendarEventContacts.length > 0 ? (
        <div className="row">
          <div className="col-12">
            <div className="table-responsive">
            <table className="table table-borderless">
              <colgroup>
                <col span={1} style={{"width": "90%"}} />
                <col span={1} style={{"width": "10%"}} />
              </colgroup>
              <tbody>
                {calendarEventContacts.map((calendarEventContact, index) => (
                  calendarEventContact.isEditing ? (
                    <tr key={index}>
                      <td colSpan={2} className="p-0">
                        <div className="card no-border mb-0" style={{'background': 'var(--od-c-f3f9fc, #f4f9fc)'}}>
                          <div className="card-body px-2">
                            <div className="row">
                              <div className="col">
                                <form onSubmit={
                                  (e) => {
                                    e.preventDefault();

                                    if(canSubmitCalendarEventContactForm(calendarEventContact)){
                                      submitCalendarEventContactForm(csrfToken, team, confirm, calendarEventContact, index);
                                    }
                                  }
                                }>
                                  <div className="form-row">
                                    <div className="col">
                                      <div className="form-row">
                                        <div className="col-12">
                                          <input type="text"
                                                 value={calendarEventContact.contact.name || ""}
                                                 onChange={
                                                   (e) => {
                                                     updateCalendarEventContactName(index, e.target.value);
                                                   }
                                                 }
                                                 style={{'borderRadius': '8px'}}
                                                 className="form-control form-control-sm"
                                                 placeholder="Name" />
                                        </div>
                                      </div>
                                      <div className="form-row pt-2">
                                        <div className="col-6">
                                          <input type="email"
                                                 value={calendarEventContact.contact.email || ""}
                                                 onChange={
                                                   (e) => {
                                                     updateCalendarEventContactEmail(index, e.target.value);
                                                   }
                                                 }
                                                 style={{'borderRadius': '8px'}}
                                                 className="form-control form-control-sm"
                                                 placeholder="Email Address" />
                                        </div>
                                        <div className="col-6">
                                          <InputMask mask="(999) 999-9999"
                                                     onChange={
                                                       (e) => {
                                                         updateCalendarEventContactPhone(index, e.target.value);
                                                       }
                                                     }
                                                     style={{'borderRadius': '8px'}}
                                                     className="form-control form-control-sm"
                                                     placeholder="Phone Number"
                                                     alwaysShowMask={false}
                                                     value={calendarEventContact.contact.phone || ""} />
                                        </div>
                                      </div>
                                      <div className="form-row pt-2">
                                        <div className="col-12">
                                          <Popup
                                            arrow={false}
                                            offsetY={5}
                                            position="bottom left"
                                            contentStyle={contactTypePopupContentStyle}
                                            trigger={open => (
                                              <div style={{
                                                ...contactTypeTriggerStyle,
                                                borderColor: open ? "#80bdff" : "var(--od-c-ced4da, #ced4da)",
                                                boxShadow: open ? "0 0 0 0.2rem rgba(0,123,255,.25)" : "none",
                                              }}>
                                                <span style={{ color: calendarEventContact.contact.contact_type ? "var(--od-c-212529, #212529)" : "var(--od-c-6c757d, #6c757d)", flex: 1 }}>
                                                  {calendarEventContact.contact.contact_type || "Contact Type"}
                                                </span>
                                                <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                                  {calendarEventContact.contact.contact_type && (
                                                    <span
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        updateCalendarEventContactContactType(index, '');
                                                      }}
                                                      style={{ color: "var(--od-c-6c757d, #6c757d)", cursor: "pointer", padding: "0 4px" }}
                                                    >
                                                      <i className="fa fa-times" style={{ fontSize: "10px" }}></i>
                                                    </span>
                                                  )}
                                                  <i className="fa fa-chevron-down" style={{ fontSize: "10px", color: "var(--od-c-6c757d, #6c757d)" }}></i>
                                                </div>
                                              </div>
                                            )}
                                          >
                                            {close => (
                                              <Select
                                                styles={contactTypePopupSelectStyles}
                                                options={contactTypeOptions}
                                                placeholder="Search contact types..."
                                                autoFocus
                                                menuIsOpen
                                                value={contactTypeOptions.find(opt => opt.value === calendarEventContact.contact.contact_type) || null}
                                                onChange={(option) => {
                                                  updateCalendarEventContactContactType(index, option ? option.value : '');
                                                  setTimeout(() => close(), 0);
                                                }}
                                                controlShouldRenderValue={false}
                                              />
                                            )}
                                          </Popup>
                                        </div>
                                      </div>
                                      <div className="form-row pt-2">
                                        <div className="col-6">
                                          <input type="text"
                                                 value={calendarEventContact.contact.title || ""}
                                                 onChange={
                                                   (e) => {
                                                     updateCalendarEventContactTitle(index, e.target.value);
                                                   }
                                                 }
                                                 style={{'borderRadius': '8px'}}
                                                 className="form-control form-control-sm"
                                                 placeholder="Title" />
                                        </div>
                                        <div className="col-6">
                                          <input type="text"
                                                 value={calendarEventContact.contact.company_name || ""}
                                                 onChange={
                                                   (e) => {
                                                     updateCalendarEventContactCompanyName(index, e.target.value);
                                                   }
                                                 }
                                                 style={{'borderRadius': '8px'}}
                                                 className="form-control form-control-sm"
                                                 placeholder="Company" />
                                        </div>
                                      </div>
                                      <div className="form-row pt-2">
                                        <div className="col-12 text-right">
                                          <button type="submit"
                                                  disabled={!canSubmitCalendarEventContactForm(calendarEventContact)}
                                                  style={{'borderRadius': '8px'}}
                                                  className="btn btn-primary btn-sm">
                                            Save Contact
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-xs-auto">
                                      <a href='#'
                                         className="mt-1 d-inline-block"
                                         onClick={
                                           (e) => {
                                             e.preventDefault();
                                             cancelEditCalendarEventContact(originalCalendarEventContact);
                                           }
                                         }
                                         style={{"color": "#91bddc"}}>
                                        <i className="fas fa-times-circle"></i>
                                      </a>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ) : calendarEventContact.id ? (
                    <tr key={index}>
                      <td className="pl-0">
                        <strong>
                          {calendarEventContact.contact.agent_permalink ? (
                            <a href={`/agents/${calendarEventContact.contact.agent_permalink}`}>
                              {calendarEventContact.contact.name}
                            </a>
                          ) : (
                            calendarEventContact.contact.name
                          )}
                          {calendarEventContact.send_daily_ticket_updates ? (
                            <i className="far fa-envelope text-primary ml-2"
                               title="Receiving daily ticket counts"></i>
                          ) : null}
                        </strong>
                        {(calendarEventContact.contact.contact_type || calendarEventContact.contact.company_name) ? (
                          <div>
                            {[calendarEventContact.contact.contact_type, calendarEventContact.contact.company_name].filter(Boolean).join(" @ ")}
                          </div>
                        ) : null}
                        {calendarEventContact.contact.email_with_phone.length > 0 ? (
                          <div className="text-muted">
                            {calendarEventContact.contact.email_with_phone}
                          </div>
                        ) : null}
                      </td>
                      <td className="pr-0 text-right" style={{"verticalAlign": "middle"}}>
                        {currentUser.can_manage_calendar_event_contacts ? (
                          <Popup arrow={false}
                                 offsetY={5}
                                 position="bottom right"
                                 contentStyle={popupContentStyle}
                                 onOpen={
                                   (e) => {
                                     e.preventDefault();
                                   }
                                 }
                                 trigger={open => (
                                   <a href="#"
                                      className="btn btn-external btn-sm note-card-inline-menu">
                                     <i className="far fa-ellipsis-v"></i>
                                   </a>
                                 )} >
                            {close => (
                              <div className='row text-left'>
                                <div className="col-12">
                                  <ul className="list-group offer-inline-menu">
                                    {confirm.type === "Confirm" ? (
                                      <>
                                        {currentUser.can_create_invitation && calendarEventContact.contact.email && calendarEventContact.contact.email.length > 0 && !confirmInvitationsAndTeamMemberships.map((d) => d.email.toLowerCase()).includes(calendarEventContact.contact.email.toLowerCase()) ? (
                                          <li className="list-group-item">
                                            <a href={"#"}
                                              onClick={
                                                (e) => {
                                                  e.preventDefault();
                                                  close();

                                                  var option = Object.assign({}, calendarEventContact.contact, {
                                                    value: calendarEventContact.contact.email
                                                  });

                                                  emailsToInviteChanged([option]);
                                                  confirmInvitationChanged({team: team});
                                                }
                                              }
                                              className="text-dark">
                                              <span className="d-inline-block text-center text-muted" style={{width: "28px"}}>
                                                <i className="fas fa-share"></i>
                                              </span>
                                              Share this Page
                                            </a>
                                          </li>
                                        ) : null}
                                        {calendarEventContact.contact.email && calendarEventContact.contact.email.length > 0 ? (
                                          <li className="list-group-item">
                                            <a href="#"
                                              onClick={
                                                (e) => {
                                                  e.preventDefault();
                                                  close();
                                                  openPreferencesModal(calendarEventContact, index);
                                                }
                                              }
                                              className="text-muted">
                                              <span className="d-inline-block text-center" style={{width: "28px"}}>
                                                <i className={"far fa-envelope " + (calendarEventContact.send_daily_ticket_updates ? "text-primary" : "text-muted")}></i>
                                              </span>
                                              <span className="text-dark">
                                                Ticket count email settings
                                              </span>
                                            </a>
                                          </li>
                                        ) : null}
                                        {calendarEventContact.send_daily_ticket_updates ? (
                                          <SendTicketCountsNowMenuItem
                                            sendNow={sendTicketCountsNowState(calendarEventContact)}
                                            sending={sendingNowId === calendarEventContact.id}
                                            onSelect={() => {
                                              close();
                                              setSendNowTarget({ calendarEventContact });
                                            }} />
                                        ) : null}
                                      </>
                                    ) : null}
                                    <li className="list-group-item">
                                      <a href="#"
                                         onClick={
                                           (e) => {
                                             e.preventDefault();
                                             close();
                                             editCalendarEventContact(index, calendarEventContact, originalCalendarEventContact);
                                           }
                                         }
                                         className="text-muted">
                                        <span className="d-inline-block text-center" style={{width: "28px"}}>
                                          <i className="fas fa-pencil"></i>
                                        </span>
                                        <span className="text-dark">
                                          Edit Contact
                                        </span>
                                      </a>
                                    </li>
                                    <li className="list-group-item delete-offer-li">
                                      <a href="#"
                                         onClick={
                                           (e) => {
                                             e.preventDefault();
                                             close();
                                             deleteCalendarEventContact(csrfToken, team, calendarEventContact);
                                           }
                                         }
                                         className="text-danger">
                                        <span className="d-inline-block text-center" style={{width: "28px"}}>
                                          <i className="fas fa-times-circle"></i>
                                        </span>
                                        Remove
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            )}
                          </Popup>
                        ) : null}
                      </td>
                    </tr>
                  ) : (
                    <tr key={index}>
                      <td colSpan={2} className="p-0">
                        <div className="card no-border mb-0" style={{'background': 'var(--od-c-f3f9fc, #f4f9fc)'}}>
                          <div className="card-body px-2">
                            <div className="row">
                              <div className="col">
                                <form>
                                  <div className="form-row">
                                    <div className="col">
                                      <AsyncCreatableSelect cacheOptions
                                                   styles={selectStyles}
                                                   placeholder={"Enter contact"}
                                                   menuPortalTarget={document.querySelector('body')}
                                                   defaultOptions
                                                   formatOptionLabel={formatOptionLabel}
                                                   formatCreateLabel={
                                                     (label) => ("Create \"" + label + "\"")
                                                   }
                                                   onCreateOption={
                                                     (label) => {
                                                       editUnsavedCalendarEventContact(label, index, originalCalendarEventContact);
                                                     }
                                                   }
                                                   onChange={
                                                     (option) => {
                                                       if(option.type === "Contact"){
                                                         createCalendarEventContactFromContactId(csrfToken, team, confirm, option.id, index);
                                                       } else if (option.type === "Agent") {
                                                         createCalendarEventContactFromAgentId(csrfToken, team, confirm, option.id, index);
                                                       }
                                                     }
                                                   }
                                                   loadOptions={(inputValue, callback) => debouncedFetch(inputValue, callback, team, calendarEventContacts)} />
                                    </div>
                                    <div className="col-xs-auto">
                                      <a href='#'
                                         className="mt-1 d-inline-block"
                                         onClick={
                                           (e) => {
                                             e.preventDefault();
                                             removeUnsavedCalendarEventContact();
                                           }
                                         }
                                         style={{"color": "#91bddc"}}>
                                        <i className="fas fa-times-circle"></i>
                                      </a>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                )
              ))}
            </tbody>
          </table>
          </div>
        </div>
      </div>
      ) : null}
      {currentUser.can_manage_calendar_event_contacts && calendarEventContacts.length > 0 && hasManuallyAddedCalendarEventContacts(calendarEventContacts) && canAddCalendarEventContact(calendarEventContacts) ? (
        <div className="row">
          <div className="col-12">
            <a href="#" onClick={
              (e) => {
                e.preventDefault();
                addCalendarEventContact(originalCalendarEventContact);
              }
            }>
              <i className="fas fa-plus-circle"></i>
              &nbsp;
              Add Contact
            </a>
          </div>
        </div>
      ) : null}
      {calendarEventContacts.length === 0 || !hasManuallyAddedCalendarEventContacts(calendarEventContacts) ? (
        <div className="row pt-3">
          <div className="col-12">
            <div className="card no-border mb-0" style={{'background': 'var(--od-c-f3f9fc, #f4f9fc)'}}>
              <div className="card-body">
                <div className="row">
                  <div className="col-12 text-center">
                    <i className="far fa-users"
                       style={{"fontSize": "60px", "color": "rgba(25, 130, 196, .5)"}}></i>
                    <h5 className="pt-2">Add Contacts</h5>
                    <p className="text-muted">
                      Add important contacts so that you can quickly reach out when you need to.
                    </p>
                    {currentUser.can_manage_calendar_event_contacts ? (
                      <a href="#"
                         onClick={
                           (e) => {
                             e.preventDefault();
                             addCalendarEventContact(originalCalendarEventContact);
                           }
                         }
                         style={{'borderRadius': '8px'}}
                         className="btn btn-primary btn-sm">
                        <strong>Add Contacts</strong>
                      </a>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      <Modal
        open={sendNowTarget !== null}
        onClose={() => setSendNowTarget(null)}
        onCancel={() => setSendNowTarget(null)}
        onConfirm={confirmSendNow}
        title={SEND_TICKET_COUNTS_NOW_TITLE}
        description={sendNowTarget ? sendTicketCountsNowMessage(sendNowTarget.calendarEventContact.contact, ticketCountsEventLabel(confirm.title, confirm.human_start_date)) : null}
        confirmLabel="Send"
      />
      <TicketUpdatePreferencesModal
        open={preferencesModalOpen}
        onClose={closePreferencesModal}
        calendarEventContact={preferencesModalContact}
        onSave={handlePreferencesSave}
        saving={preferencesModalSaving}
      />
    </div>
  </div>
  );
};

ManageContacts.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  confirm: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  calendarEventContacts: PropTypes.array,
  createCalendarEventContactFromContactId: PropTypes.func.isRequired,
  deleteCalendarEventContact: PropTypes.func.isRequired,
  addCalendarEventContact: PropTypes.func.isRequired,
  removeUnsavedCalendarEventContact: PropTypes.func.isRequired,
  editCalendarEventContact: PropTypes.func.isRequired,
  cancelEditCalendarEventContact: PropTypes.func.isRequired,
  updateCalendarEventContactName: PropTypes.func.isRequired,
  updateCalendarEventContactEmail: PropTypes.func.isRequired,
  updateCalendarEventContactPhone: PropTypes.func.isRequired,
  updateCalendarEventContactContactType: PropTypes.func.isRequired,
  updateCalendarEventContactTitle: PropTypes.func.isRequired,
  updateCalendarEventContactCompanyName: PropTypes.func.isRequired,
  submitCalendarEventContactForm: PropTypes.func.isRequired,
  editUnsavedCalendarEventContact: PropTypes.func.isRequired,
  originalCalendarEventContact: PropTypes.object,
  createCalendarEventContactFromAgentId: PropTypes.func.isRequired,
  updateCalendarEventContact: PropTypes.func.isRequired,
  sendCalendarEventContactTicketCounts: PropTypes.func.isRequired,
  confirmInvitationChanged: PropTypes.func.isRequired,
  emailsToInviteChanged: PropTypes.func.isRequired,
  confirmInvitationsAndTeamMemberships: PropTypes.array,
  confirmPageSection: PropTypes.object,
  fetchPermissionSet: PropTypes.func.isRequired,
  updateConfirmPageSection: PropTypes.func.isRequired
};

export default ManageContacts;
